import { render, staticRenderFns } from "./ListConfigDialog.vue?vue&type=template&id=15f7e034&scoped=true"
import script from "./ListConfigDialog.vue?vue&type=script&lang=js"
export * from "./ListConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./ListConfigDialog.vue?vue&type=style&index=0&id=15f7e034&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f7e034",
  null
  
)

export default component.exports